module.exports = __webpack_public_path__ + "img/31.89ee8696.png";